/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Form } from "antd";
import { useFieldArray, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AssigneesTerms from "./Tabs/AssigneesTerms";
import FullPageLayout from "../../../templates/FullPageLayout";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { ErrorMessage } from "../../../atoms/Toasts/ErrorMessage";
import { AxiosError } from "axios";
import { SuccessMessage } from "../../../atoms/Toasts/SuccessMessage";
import dayjs, { Dayjs } from "dayjs";
import { sendProposalToProduction } from "../../PotentialDeals/ducks/services";
import {
  getPotentialDealDetails,
  getSendToProductionFormData,
} from "../../PotentialDeals/ducks/actions";
import { getContractDetailById } from "../ducks/actions";

interface FormValues {
  start_date: string | Dayjs;
  end_date: string | Dayjs;
  net_terms: string;
  billing: string;
  manager_id: string;
  production: {
    id: string;
    name: string;
    production_manager_id: string;
    crew_id: string;
    service_line_id: string;
  }[];
}

export default function EditContracts() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const dealId = pathSegments[pathSegments.length - 2];
  const proposalId = pathSegments[pathSegments.length - 3];
  const contractId = pathSegments[pathSegments.length - 4];
  const [loading, setLoading] = useState(false);
  const [renewOption, setRenewOption] = useState("yes");
  const [pricingOption, setPricingOption] = useState("fixed_price");

  const productionFormData = useAppSelector(
    (state) => state?.potentialDeal?.productionFormData
  );

  const dealsDetailData = useAppSelector(
    (state) => state?.potentialDeal?.dealsDetailData
  );

  const contractDetailDataById = useAppSelector(
    (state) => state?.contract?.contractDetailDataById
  );

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "production",
  });

  const onSubmit = (val: FormValues) => {
    setLoading(true);
    const payload = {
      potential_deal_id: dealId,
      proposal_id: proposalId,
      service_lines: val?.production,

      manager_id: val?.manager_id ? val?.manager_id : "",
      company_id: companyId,
      start_date: val?.start_date
        ? dayjs(val?.start_date).format("YYYY-MM-DD")
        : "",
      end_date: val?.end_date ? dayjs(val?.end_date).format("YYYY-MM-DD") : "",
      renewable: renewOption === "yes" ? true : false,
      pricing_model: pricingOption,
      billing: val?.billing ? val?.billing : "",
      net_terms: val?.net_terms ? val?.net_terms : "",
    };

    console.log("payload", payload);

    sendProposalToProduction(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Estimate send to production");
        navigate(-1);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  useEffect(() => {
    if (productionFormData?.data) {
      const fieldsArray =
        productionFormData?.data?.estimateServiceLineData?.map(
          (serviceLine: any) => ({
            id: serviceLine.id,
            name: serviceLine.name,
            production_manager_id: serviceLine.manager_id,
            crew_id: serviceLine.crew_id,
            service_line_id: serviceLine.id,
          })
        );

      setValue("production", fieldsArray);
      // setValue("manager_id", productionFormData?.data?.proposal);
    }
  }, [productionFormData, setValue]);

  useEffect(() => {
    if (dealsDetailData?.data) {
      if (dealsDetailData?.data?.start_date) {
        const startDate = dayjs(dealsDetailData?.data?.start_date);
        if (startDate.isValid()) {
          setValue("start_date", startDate);
        }
      }
      if (dealsDetailData?.data?.end_date) {
        const endDate = dayjs(dealsDetailData?.data?.end_date);
        if (endDate.isValid()) {
          setValue("end_date", endDate);
        }
      }
      setValue("billing", dealsDetailData?.data?.billing);
      setValue("net_terms", dealsDetailData?.data?.net_terms);
      setRenewOption(dealsDetailData?.data?.renewable ? "yes" : "no");
      setPricingOption(dealsDetailData?.data?.pricing_model);
    }
  }, [dealsDetailData, setValue]);

  useEffect(() => {
    if (proposalId) {
      dispatch(getSendToProductionFormData(proposalId));
    }
  }, [proposalId, dispatch]);

  useEffect(() => {
    if (dealId && contractId) {
      dispatch(getPotentialDealDetails(dealId, contractId));
      dispatch(getContractDetailById(contractId));
    }
  }, [dispatch, dealId, contractId]);

  console.log("contractDetailDataById", contractDetailDataById);

  return (
    <FullPageLayout
      loading={
        loading || productionFormData?.loader || contractDetailDataById?.loader
      }
    >
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <Col style={{ width: "672px", paddingBottom: 85 }}>
          <div className="title">
            <h2 style={{ marginBottom: "4px" }}>Edit general details</h2>
            <p style={{ fontSize: "16px" }}>
              Complete the information below to start executing work on this
              contract.
            </p>
          </div>

          <div className="ServicesSteps">
            <div className="service_tabs">
              <AssigneesTerms
                control={control}
                errors={errors}
                append={append}
                fields={fields}
                remove={remove}
                renewOption={renewOption}
                pricingOption={pricingOption}
                setValue={setValue}
                setLoading={setLoading}
                setRenewOption={setRenewOption}
                setPricingOption={setPricingOption}
                productionFormData={productionFormData?.data || null}
                contractDetailDataById={contractDetailDataById?.data || null}
              />
            </div>
          </div>
        </Col>
        <div className="fixed_btm_card">
          <Card>
            <div className="centered">
              <Button
                htmlType="button"
                className="outlined-btn"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <div style={{ display: "flex", gap: "16px" }}>
                <Button htmlType="submit" type="primary" className="mint-btn">
                  Continue
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </Form>
    </FullPageLayout>
  );
}
